/* eslint class-methods-use-this: 0 */
import BaseController from './BaseController';
import UploadDataSource from '../dataSources/UploadDataSource';


class UploadController extends BaseController {
    static get name() {
        return 'UploadController';
    }

    static getInstance(options) {
        return new UploadController(options);
    }

    onActivate() {
        this.bindGluBusEvents({
        });
        this.uploadDataSource = this.activateSource(UploadDataSource);
    }

    onDeactivate() {
        this.unbindGluBusEvents();
    }
}

export default UploadController;
